import produce from 'immer'
import { CaseworkerActionType } from '../../action-types'
import { CaseworkerAction } from '../../actions'
import { ApiOrganization } from '../../../ts/api-types'

interface PlanInterface {
    id: number
    name: string
    employee_count: string
    price_monthly: number
    price_yearly: number
    currency: null | 'EUR' | 'SEK'
}

interface CaseworkerUser {
    userId: number
    firstName: string
    lastName: string
    email: string
    activeCases: number
    phone: { country_code: string; phone: string }
    selected_language: unknown
}

export interface CaseworkerIdentityState {
    user: CaseworkerUser | null
    organization: ApiOrganization | null
    plan: PlanInterface | null
}

const initialState: CaseworkerIdentityState = {
    user: null,
    organization: null,
    plan: null,
}

const reducer = produce(
    (
        state: CaseworkerIdentityState = initialState,
        action: CaseworkerAction
    ) => {
        switch (action.type) {
            case CaseworkerActionType.GET_SELF:
                const user = {
                    userId: action.payload.id,
                    firstName: action.payload.first_name,
                    lastName: action.payload.last_name,
                    email: action.payload.email,
                    activeCases: action.payload.active_cases,
                    phone: action.payload.phone,
                    selected_language: action.payload.selected_language,
                }

                if (action.payload.plan) {
                    state.plan = action.payload.plan.data
                }

                state.user = user
                // For partner users, the identity API returns a PartnerOrganization
                // under the "organization" include (via UserTransformer), which has
                // a different shape than a client Organization. The optional chain
                // prevents crashes when the payload shape doesn't match what the
                // client-side code expects. This is a temporary guard — partner
                // users should ideally have their own dedicated state/components
                // rather than sharing client-oriented reducers.
                state.organization = action.payload.organization?.data ?? null
                return state

            case CaseworkerActionType.GET_SELF_ORGANIZATION:
                state.organization = action.payload
                return state

            default:
                return state
        }
    }
)

export default reducer
